/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { IceEntity } from '../../core/IceEntity';

export class encounterprogressnotesreference extends IceEntity {
	encounter_progress_notes_reference_key: string = "";
  encounter_progress_notes_key: string = "";
  encounter_key: string = "";
  record_version: number = 0;
  offline_record_status: number = 0;

  gettablename(): string {
    return "ENCOUNTER_PROGRESS_NOTES_REFERENCE";
  }
}
